import React, { type ReactNode } from 'react';
import { Collapse, type CollapseProps } from 'antd';
import classNames from 'classnames';
import ArrowDown from '~/public/assets/images/svg/arrow-down.svg';

interface CollapseDetailProps extends CollapseProps {
  children?: ReactNode;
  panelHeader?: string;
  panelClassName?: string;
}
function CollapseDetail({
  children,
  items,
  className,
  panelClassName,
  panelHeader,
  defaultActiveKey = ['1'],
  ...rest
}: CollapseDetailProps) {
  const collapseItems = items ?? [
    {
      key: '1',
      label: panelHeader,
      children,
      className: panelClassName,
    },
  ];

  return (
    <Collapse
      bordered={false}
      items={collapseItems}
      defaultActiveKey={defaultActiveKey}
      className={classNames(
        'collaps-component my-4 w-full bg-transparent !text-xs',
        className
      )}
      expandIcon={({ isActive }) => (
        <ArrowDown style={{ transform: `rotate(${isActive ? 180 : 0}deg)` }} />
      )}
      {...rest}
    />
  );
}

export default CollapseDetail;
